// src/pages/LoginPage.tsx
import axios from "axios";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import TextField from "../components/textfield/TextField";
import "../styles/Login.css"
import Dialog, { DialogProps } from "../components/dialog/Dialog";

const Login: React.FC = () => {
  const [mobile, setMobile] = useState("");
  const [inputError, setInputError] = useState<boolean>(false);
  const [alert, setAlert] = useState<DialogProps | null>(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();


  const handleSignIn2 = async () => {
    console.log(mobile)
    const mobileRegex = /^[6-9]\d{9}$/;
    if (!mobileRegex.test(mobile)) return setInputError(true)
    navigate("/otp", { state: { mobile } });
  }


  const handleSignIn = async () => {
    console.log(mobile)
    const mobileRegex = /^[6-9]\d{9}$/;
    if (!mobileRegex.test(mobile)) return setInputError(true)
    try {
      setLoading(true);
      const res = await axios.post("https://uragate.in/websites/springapi/driver-registration/v1/auth/login/send-otp", { mobileNumber: mobile });
      navigate("/otp", { state: { mobile } });
    } catch (error: any) {
      console.error(error);
      setAlert({
        type: "error",
        title: "Error",
        message: error.response?.data?.message || "Failed to send otp.",
        btnName: "Okay",
        onClick() {
          setAlert(null)
        },
      });
    } finally {
      setLoading(false);
    }
  };

  const handleMobileChange = (name: string, e: string) => {
    const value = e.replace(/\D/g, "");
    if (value.length <= 10) {
      setMobile(value);
      setInputError(false)
    }
    if (value.length == 10) {
      const mobileRegex = /^[6-9]\d{9}$/;
      if (!mobileRegex.test(value)) return setInputError(true)
    }
  };

  return (
    <div className="login-page">
      <div className="spacer"></div>
      <div className="login-main-container">
        <h2 className="login-title-text">Driver Login/Signup</h2>
        <TextField
          label={"Mobile number"}
          name={"mobile"}
          placeholder="Enter mobile number"
          value={mobile}
          onChange={handleMobileChange}
          error={inputError}
          disabled={loading}
        />
        <button className={`otp-send-btn`} onClick={handleSignIn} disabled={loading}>{loading ? "Sending OTP...." : "Send OTP"}</button>
      </div>
      <a className="help-btn" href="https://uracab.com/contact">Need Help?</a>
      <div className="spacer"></div>
      {alert &&
        <Dialog type={alert.type} title={alert.title} message={alert.message} btnName={alert.btnName} onClick={alert.onClick} />
      }
    </div>
  );
};

export default Login;
